export default "__VITE_ASSET__779oaBLw__"